import { Row, Space } from 'antd';
import { ReactNode } from 'react';
import LanguageDropdown from '../../../components/LanguageDropdown';
import CardContainer from '../../../containers/CardContainer';

const RequestsLayout = ({ children }: { children: ReactNode }) => {
    return (
        <CardContainer id="request-card" style={{ minWidth: '300px', width: '700px' }}>
            <Space direction="vertical" size="small" className="full-width">
                <Row justify="end" align="middle">
                    <LanguageDropdown />
                </Row>
                {children}
            </Space>
        </CardContainer>
    );
};
export default RequestsLayout;
